/**
 * Generated from ch1_p010.fla
 */
export function ch1_p010(this: Ich1_p010) {
	const background = this.background;
	ch1_p010_hh_ch1_72dpi_p010psdAssetcp1_p10_background.call(this.background);
	background.x = 832;
	background.y = 384;
	background.width = 1664.00;
	background.height = 768.00;
	background.alpha = 1.00;
	if (background.onLayout) background.onLayout();
	const lines = this.lines;
	ch1_p010_hh_ch1_72dpi_p010psdAssetcp1_p10_lines1.call(this.lines);
	lines.x = 893.75;
	lines.y = 452;
	lines.width = 656.00;
	lines.height = 420.00;
	lines.alpha = 0.47;
	if (lines.onLayout) lines.onLayout();
	const arm = this.arm;
	ch1_p010_hh_ch1_72dpi_p010psdAssetcp1_p10_arm.call(this.arm);
	arm.x = 760.5;
	arm.y = 333.5;
	arm.width = 565.00;
	arm.height = 667.00;
	arm.alpha = 1.00;
	if (arm.onLayout) arm.onLayout();
	const phone = this.phone;
	ch1_p010_hh_ch1_72dpi_p010psdAssetcp1_p10_phone.call(this.phone);
	phone.x = 885.75;
	phone.y = 500.75;
	phone.width = 601.50;
	phone.height = 492.50;
	phone.alpha = 1.00;
	if (phone.onLayout) phone.onLayout();
	const handFront = this.handFront;
	ch1_p010_hh_ch1_72dpi_p010psdAsset1cp1_p10_handcover.call(this.handFront);
	handFront.x = 840.75;
	handFront.y = 477;
	handFront.width = 404.50;
	handFront.height = 380.00;
	handFront.alpha = 1.00;
	if (handFront.onLayout) handFront.onLayout();
	const frame = this.frame;
	ch1_p010_hh_ch1_72dpi_p010psdAssetcp1_p10_wcframe.call(this.frame);
	frame.x = 832;
	frame.y = 384;
	frame.width = 1664.00;
	frame.height = 768.00;
	frame.alpha = 1.00;
	if (frame.onLayout) frame.onLayout();
	return this;
}
function ch1_p010_hh_ch1_72dpi_p010psdAssetcp1_p10_background(this: Ich1_p010_hh_ch1_72dpi_p010psdAssetcp1_p10_background) {
	if (this.setLayoutTexture) this.setLayoutTexture("cp1_p10_background", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p010_hh_ch1_72dpi_p010psdAssetcp1_p10_lines1(this: Ich1_p010_hh_ch1_72dpi_p010psdAssetcp1_p10_lines1) {
	if (this.setLayoutTexture) this.setLayoutTexture("cp1_p10_lines1", 0.493, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p010_hh_ch1_72dpi_p010psdAssetcp1_p10_arm(this: Ich1_p010_hh_ch1_72dpi_p010psdAssetcp1_p10_arm) {
	if (this.setLayoutTexture) this.setLayoutTexture("cp1_p10_arm", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p010_hh_ch1_72dpi_p010psdAssetcp1_p10_phone(this: Ich1_p010_hh_ch1_72dpi_p010psdAssetcp1_p10_phone) {
	if (this.setLayoutTexture) this.setLayoutTexture("cp1_p10_phone", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p010_hh_ch1_72dpi_p010psdAsset1cp1_p10_handcover(this: Ich1_p010_hh_ch1_72dpi_p010psdAsset1cp1_p10_handcover) {
	if (this.setLayoutTexture) this.setLayoutTexture("cp1_p10_handcover", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch1_p010_hh_ch1_72dpi_p010psdAssetcp1_p10_wcframe(this: Ich1_p010_hh_ch1_72dpi_p010psdAssetcp1_p10_wcframe) {
	if (this.setLayoutTexture) this.setLayoutTexture("cp1_p10_wcframe", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ich1_p010Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich1_p010Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich1_p010Sprite extends Ich1_p010Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich1_p010Text extends Ich1_p010Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich1_p010Polygon extends Array<number> {
}
interface Ich1_p010 {
	readonly background: Ich1_p010_hh_ch1_72dpi_p010psdAssetcp1_p10_background;
	readonly lines: Ich1_p010_hh_ch1_72dpi_p010psdAssetcp1_p10_lines1;
	readonly arm: Ich1_p010_hh_ch1_72dpi_p010psdAssetcp1_p10_arm;
	readonly phone: Ich1_p010_hh_ch1_72dpi_p010psdAssetcp1_p10_phone;
	readonly handFront: Ich1_p010_hh_ch1_72dpi_p010psdAsset1cp1_p10_handcover;
	readonly frame: Ich1_p010_hh_ch1_72dpi_p010psdAssetcp1_p10_wcframe;
}
interface Ich1_p010_hh_ch1_72dpi_p010psdAssetcp1_p10_background extends Ich1_p010Sprite {
}
interface Ich1_p010_hh_ch1_72dpi_p010psdAssetcp1_p10_lines1 extends Ich1_p010Sprite {
}
interface Ich1_p010_hh_ch1_72dpi_p010psdAssetcp1_p10_arm extends Ich1_p010Sprite {
}
interface Ich1_p010_hh_ch1_72dpi_p010psdAssetcp1_p10_phone extends Ich1_p010Sprite {
}
interface Ich1_p010_hh_ch1_72dpi_p010psdAsset1cp1_p10_handcover extends Ich1_p010Sprite {
}
interface Ich1_p010_hh_ch1_72dpi_p010psdAssetcp1_p10_wcframe extends Ich1_p010Sprite {
}
